export interface TutorialWindowDimensions {
  width: number;
  height: number;
}

export interface TutorialLayoutOptions extends TutorialWindowDimensions {
  isWeb: boolean;
}

/**
 * Full-screen tutorial shell dimensions. Uses live window size so rotation and
 * web resize keep paging and slide bounds correct (avoids module-load Dimensions).
 *
 * On mobile browsers, `100vh` is often taller than the visible viewport (URL bar),
 * which clips content with `overflow: 'hidden'`. Use the same numeric `height` as native.
 */
export function getTutorialLayoutStyles({ width, height, isWeb }: TutorialLayoutOptions) {
  return {
    container: {
      flex: 1,
      ...(isWeb && {
        overflow: 'hidden' as never,
        minHeight: height,
      }),
    },
    flatListContent: {
      height,
    },
    slideWrapper: {
      width,
      height,
    },
  };
}
